import { ShieldCheck } from 'lucide-react';
import LegalLinks from '@/components/LegalLinks';
import MfaSettingsCard from '@/components/settings/MfaSettingsCard';
import { useApp } from '@/contexts/AppContext';
import {
  AppButton,
  AppCard,
  AppCardBody,
  AppCardHeader,
  AppContentContainer,
  AppPageIntro,
  AppSectionHeader,
  AppShell,
  AppText,
} from '../../ui-foundation';

export default function SecureAccountPage() {
  const { role, signOut } = useApp();
  const accessLabel = role === 'admin' ? 'admin' : 'moderator';

  return (
    <AppShell className="min-h-screen justify-center px-4 py-6 sm:py-10">
      <AppContentContainer maxWidth={620} className="w-full animate-fade-in">
        <div className="rounded-[32px] border border-border bg-card/95 p-4 shadow-sm sm:p-5">
          <div className="rounded-[28px] border border-primary/10 bg-[linear-gradient(180deg,rgba(107,53,102,0.08),rgba(255,255,255,0.92))] px-5 py-6 sm:px-7 sm:py-7">
            <AppPageIntro
              title="Secure your privileged access"
              subtitle={`Before Adulting unlocks ${accessLabel} tools, add an authenticator app to this account.`}
            />
          </div>

          <div className="mt-4">
            <AppCard>
              <AppCardHeader>
                <AppSectionHeader
                  title="Two-step verification is required"
                  subtitle="This extra step protects moderation and admin tools before Adulting unlocks privileged access."
                />
              </AppCardHeader>
              <AppCardBody>
                <div className="space-y-4">
                  <div className="flex items-start gap-2">
                    <ShieldCheck size={16} className="mt-0.5 text-primary" />
                    <AppText color="$colorMuted" fontSize="$sm">
                      This account can review reports, moderation actions, or admin content. Two-step
                      verification is required to keep that access safer.
                    </AppText>
                  </div>

                  <MfaSettingsCard
                    enforced
                    enforcedReason="Privileged accounts must keep two-step verification on before Adulting unlocks admin or moderation tools."
                  />

                  <AppButton size="sm" tone="outline" onPress={() => void signOut()}>
                    Sign out instead
                  </AppButton>
                </div>
              </AppCardBody>
            </AppCard>

            <div className="mt-4 rounded-[24px] border border-border bg-card/80 px-5 py-4 shadow-sm">
              <LegalLinks />
            </div>
          </div>
        </div>
      </AppContentContainer>
    </AppShell>
  );
}
